import script from "./UsuarioProximasReservas.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuarioProximasReservas.vue?vue&type=script&setup=true&lang=js"

import "./UsuarioProximasReservas.vue?vue&type=style&index=0&id=78883bd3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78883bd3"]])

export default __exports__